import { createSmartTaxUploadCard } from './createSmartTaxUploadCard';
import {
  SMART_TAX_RETURN_CARD_CONFIG,
  SmartTaxReturnTechnicalSpecs,
} from './smartTaxImportCards';

/** Upload card for the tax-return organizer pilot. */
export const SmartTaxReturnUploadCard = createSmartTaxUploadCard(
  SMART_TAX_RETURN_CARD_CONFIG,
  SmartTaxReturnTechnicalSpecs
);
